export const customAttributesFilterAssets = {
    text: {
        operators: ['is_not_empty', 'is_empty'],
    },
    select: {
        operators: ['is_one', 'is_not_one', 'is_empty', 'is_not_empty'],
    },
};
